import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/customers/customers.scss";
import IbuttonTable from "./ibuttonTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import Search from "../commoncomponents/Search";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";

class Ibutton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ibuttonList: [],
      searchKey: "",
      pageCount: 0,
      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "1",
      entryEnd: "50",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,
    };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
  }

  componentDidMount() {
    var urlAll = "";

    let query = encodeQueryData(this.setIbuttonQueryObject());
    urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  }

  handleShowEntries = (inputShowEntries) => {
    this.pageSize = inputShowEntries;

    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;

    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  setIbuttonQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;

    return data;
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  handleSearch = (inputSearch) => {
    if (inputSearch == "") {
      this.setState({ filterMessage: false });
    } else {
      this.setState({ filterMessage: true });
    }

    this.searchText = inputSearch;
    let query = encodeQueryData(this.setIbuttonQueryObject());
    let urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
    this.getIbutton(urlAll);
  };

  getIbutton = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      let ibuttonList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      console.log("list", ibuttonList);
      this.setState({
        ibuttonList: ibuttonList.data,
        pageCount: JSON.parse(ibuttonList.headers.pagination).totalPages,
      });
      this.handleShowResults(ibuttonList);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }else{
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleShowResults = (ibuttonList) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(ibuttonList.headers.pagination).totalItems,
    });
    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(ibuttonList.headers.pagination).totalItems,
        totalFilter: true,
      });
    }
    this.setState({
      entryStart: (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });
    if (
      JSON.parse(ibuttonList.headers.pagination).totalItems <
      parseInt(this.state.entryEnd)
    ) {
      this.setState({
        entryEnd: JSON.parse(ibuttonList.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(ibuttonList.headers.pagination).currentPage) *
        parseInt(this.pageSize);
      this.setState({ entryEnd: value });
    }
    if (
      this.state.entryEnd >
      parseInt(JSON.parse(ibuttonList.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEnd: JSON.parse(ibuttonList.headers.pagination).totalItems,
      });
    }
    if (this.state.ibuttonList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };



  render() {
    const { pageCount } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All iButtons </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>All iButtons</h2>

              <div className="inline">

                <div></div>
                <div>
                  <Search searchCallback={this.handleSearch} />
                </div>
              </div>
              <div className="userTable">

                <IbuttonTable
                  customers={this.state.ibuttonList}
                  sortFunction={this.handleSort}
                ></IbuttonTable>
              </div>
              <div className="paginationDetails">
                <ShowingResults
                  currentEntryStart={this.state.entryStart}
                  currentEntryEnd={this.state.entryEnd}
                  totalEntries={this.state.totalEntry}
                  totalFilterEntries={this.state.totalEntryFilter}
                  filterMessage={this.state.filterMessage}
                />
                <Paginations
                  onPagination={this.handlePagination}
                  pageCount={pageCount}
                  pageRange={5}
                ></Paginations>
              </div>

            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Ibutton);
// <IbuttonTable
//     customers={ibuttonList}
//     onDetail={this.handleDetail}
//     sortFunction={this.handleSort}
// >
// </IbuttonTable>
